import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { DxDataGridComponent } from "devextreme-angular";
import { UserService } from '../../../../../shared/services/user.service';
import { EmployeePortalService } from '../../../_api/services/employee-portal.service';
import { LanguageService } from '../../../../../shared/services/language.service';

@Component({
  selector: 'app-employee-list-balance-per-employee',
  templateUrl: './employee-list-balance-per-employee.component.html',
  styleUrls: ['./employee-list-balance-per-employee.component.css']
})
export class EmployeeListBalancePerEmployeeComponent implements OnInit {

  @ViewChild('timebankTimes', {static:false}) dataGridTimebankTimes: DxDataGridComponent;
  @ViewChild('balanceLogg', {static:false}) dataGridBalanceLogg: DxDataGridComponent;

  @Input() employeeId: number;
  @Input() balanceId: number;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(employee-portal.component) to show load indicator
  isLoading: boolean = false; 
  @Output() closeTab = new EventEmitter<void>();

  dataSource: any;
  dataSourceBalanceLog: any;
  from: string;
  to: string;
  labels = {
    Unconfirmed: '',
    Confirmed: '',
    Approved: '',
    ReadyToSalary: '',
    TransferredToSalary: ''
  };
  statusFilterData = [];
  lblTitle: string;
  lblTitleLogg: string;

  constructor(private userService: UserService, private employeePortalService: EmployeePortalService, public languageService: LanguageService) {
  }

  ngOnInit() {
    this.from = moment().format("DD.MM.YYYY");
    this.to = moment().format("DD.MM.YYYY");
    this.lblTitle = this.languageService.LNG("Label.Time.Bank") + " " + this.languageService.LNG("Label.Hours");
    this.lblTitleLogg = this.languageService.LNG("Label.Time.Bank") + " " + this.languageService.LNG("Label.Logg");
    this.labels.Approved = this.languageService.LNG("Label.Is.Approved");
    this.labels.Confirmed = this.languageService.LNG("Label.Confirmed");
    this.labels.Unconfirmed = this.languageService.LNG("Label.Unconfirmed");
    this.labels.ReadyToSalary = this.languageService.LNG("Label.Ready.For.Salary");
    this.labels.TransferredToSalary = this.languageService.LNG("Label.Transferred.Salary");
    this.statusFilterData = [];
    this.statusFilterData.push( {
      text: this.labels.Unconfirmed,
      value: ["StatusId", "=", 2]
    });
    this.statusFilterData.push( {
      text: this.labels.Confirmed,
      value: ["StatusId", "=", 3]
    });
    this.statusFilterData.push( {
      text: this.labels.Approved,
      value: ["StatusId", "=", 4]
    });
    this.statusFilterData.push( {
      text: this.labels.ReadyToSalary,
      value: ["StatusId", "=", 5]
    });
    this.statusFilterData.push( {
      text: this.labels.TransferredToSalary,
      value: ["StatusId", "=", 99]
    });
  }

  ngOnChanges() {
    this.refresh();
  }

  private async refresh() {
    this.loading.emit(true);
    this.isLoading = true; 
    await this.loadTimePosts(false);
    await this.loadBalanceLogg(false);
    this.loading.emit(false);
    this.isLoading = false; 
  }

  private async loadTimePosts(refreshSearchCriterias: boolean = true) {
    await this.employeePortalService.getListBalanceTimePosts(this.employeeId, this.balanceId, this.from, this.to).toPromise().then(result => {
      this.dataSource = result.Data;
      if (refreshSearchCriterias) {
        this.clearDataGridSelections();
      }
    });
  }

  private async loadBalanceLogg(refreshSearchCriterias: boolean = true) {
    await this.employeePortalService.getListBalanceLogg(this.employeeId, this.balanceId, this.from, this.to).toPromise().then(result => {
      this.dataSourceBalanceLog = result.Data;
      if (refreshSearchCriterias) {
        this.clearDataGridSelections();
      }
    });
  }

  clearDataGridSelections() {
    this.dataGridTimebankTimes.instance.clearFilter();
    this.dataGridTimebankTimes.instance.clearGrouping();
    this.dataGridTimebankTimes.instance.clearSelection();
    this.dataGridTimebankTimes.instance.clearSorting();
  }

  clearDataGridSelectionsLogg() {
    this.dataGridBalanceLogg.instance.clearFilter();
    this.dataGridBalanceLogg.instance.clearGrouping();
    this.dataGridBalanceLogg.instance.clearSelection();
    this.dataGridBalanceLogg.instance.clearSorting();
  }

  dateChanged(dateInterval: any) {
    this.from = moment(dateInterval.FromDate).format("DD.MM.YYYY");
    this.to = moment(dateInterval.ToDate).format("DD.MM.YYYY");
    this.refresh();
  }

  //show grouped date as "dddd DD.MM.YYYY". the date from dataField has format DD.MM.YYYY
  groupTemplate(data) {
    let date = data.value;
    // let dt = moment(date);
    let dt = moment(date, "YYYY-MM-DD");
    console.log("dt", dt);
    var nb = moment(dt).locale('nb');
    let dateDDMMYYYY = nb.format('dddd DD.MM.YYYY');
    return dateDDMMYYYY;
  }

  //show grouped date as "dddd DD.MM.YYYY". the date from dataField has format DD.MM.YYYY
  groupTemplateTimeStamp(data) {
    let date = data.value;
    // let dt = moment(date);
    let dt = moment(date, "YYYY-MM-DD HH:mm");
    console.log("dt", dt);
    var nb = moment(dt).locale('nb');
    let dateDDMMYYYY = nb.format('dddd DD.MM.YYYY HH:mm');
    return dateDDMMYYYY;
  }

  //sort datestring as date
  customDateSort (rowData) {
    return rowData.Date;
  }

  //sort datestring as date
  customTimeStampSort (rowData) {
    return rowData.TimeStamp;
  }

  calculateSummary(options) {
    // Calculating "customSummary1"
    if(options.name == "customSumHours") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.Seconds > 0)
                {
                  options.totalValue += options.value.Seconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if (options.name == "customSumHoursDecimal") {
      switch(options.summaryProcess) {
          case "start":
              // Initializing "totalValue" here
              options.totalValue = 0;
              break;
          case "calculate":
              if (options.value.Seconds > 0)
              {
                parseFloat
                options.totalValue += options.value.Seconds;
              }
              // Modifying "totalValue" here
              break;
          case "finalize":

              // Assigning the final value to "totalValue" here
              let hours = options.totalValue / 3600;
              let rounded = (Math.round(hours * 100) / 100).toFixed(2);
              // let min = (options.totalValue / 60) % 60;
              options.totalValue = rounded.replace(".", ",");
              break;
      }
    }
  }

  onCellPrepared(e) {
    if (e.rowType === "data") {
      // if (e.columnIndex == 0) {

      //   switch (e.key.StatusId) {
      //     case 2:
      //       e.cellElement.title = this.labels.Unconfirmed;
      //       break;
      //     case 3:
      //       e.cellElement.title = this.labels.Confirmed;
      //       break;
      //     case 4:
      //       e.cellElement.title = this.labels.Approved;
      //       break;
      //     case 5:
      //       e.cellElement.title = this.labels.ReadyToSalary;
      //       break;
      //     case 99:
      //       e.cellElement.title = this.labels.TransferredToSalary;
      //       break;
      //     default:
      //       e.cellElement.style.backgroundColor = "#88B0C5"
      //       e.cellElement.title = "Udefinert Status";
      //       break;
      //   }
      // }
    }
  }

  onCloseClick() {
    this.closeTab.emit();
  }

}
